import IntegrationTaskListResultModelBase from '../_generated/modelBases/integration-task-list-result-model-base';

export default class IntegrationTaskListResultModel extends IntegrationTaskListResultModelBase {
  // For instructions on how to use Models visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/429/ServiceModels-DTOs
}
